import { useEffect } from 'preact/hooks'
import { useSignal } from '@preact/signals'
import { Text } from 'preact-i18n'
import screenFull from 'screenfull'

import { ShadowText } from '../atoms'
import { isTouchDevice } from '../../utils'

type TouchEventListener = (e: MouseEvent | TouchEvent) => void

const wrapListener = (func: TouchEventListener, DOUBLE_PRESS_DELAY = 300): TouchEventListener => {
  let lastPress = 0
  return function wrappedListener(event: MouseEvent | TouchEvent) {
    const time = new Date().getTime()
    const delta = time - lastPress

    if (delta < DOUBLE_PRESS_DELAY) {
      func(event)
    }
    lastPress = time
  }
}

const EVENT_NAME = isTouchDevice() ? 'touchend' : 'dblclick'

const FullScreenInfo = () => {
  const isFullScreen = useSignal(screenFull.isFullscreen)
  useEffect(() => {
    const listener = async () => {
      await screenFull.toggle(document.body)
    }
    document.body.addEventListener(EVENT_NAME, isTouchDevice() ? wrapListener(listener) : listener)
    return () => document.body.removeEventListener(EVENT_NAME, isTouchDevice() ? wrapListener(listener) : listener)
  }, [wrapListener])

  useEffect(() => {
    const onFullScreenChange = (_: Event) => {
      if (screenFull.element) {
        isFullScreen.value = true
        return
      }
      isFullScreen.value = false
    }
    document.body.addEventListener('fullscreenchange', onFullScreenChange)
    return () => document.body.removeEventListener('fullscreenchange', onFullScreenChange)
  }, [])

  return (
    <ShadowText>
      <Text
        id={`info.fullscreen.${isTouchDevice() ? 'touch' : 'click'}.${isFullScreen.value ? 'exit' : 'enter'}`}
      ></Text>
    </ShadowText>
  )
}

export default FullScreenInfo
